import React from "react"
import { Link } from "gatsby"
import KidsLicenseImg from '../../../images/licence-open.png'
import EpisodeCardImg from '../../../images/ep-0-card.png'

import "./CardsSection.scss"

const CardsSection = () => {

	return (
		<div className="row sticker-win">
			<div className="col-12 col-md-6">
				<div className="collectstickers sticker">
					<img src={KidsLicenseImg} className="sticker-img" alt="PhoneSmart Licence" />
					<div className="sticker-content">
						<h3>GET your licence</h3>
						<div className="sub-head">Complete all 5 Episodes</div>
						<p>It's easy! Just play and complete each episode to earn a sticker. When you've got all five you get your PhoneSmart Licence.</p>
					</div>
				</div>
			</div>
			<div className="col-12 col-md-6">
				<div className="collectstickers sticker">
					<img src={EpisodeCardImg} className="sticker-img" alt="The big reveal" />
					<div className="sticker-content">
						<h3>Play the first episode</h3>
						<div className="sub-head">Get your first sticker</div>
						<p>Join our four friends, Mei, Lily, Jayden, and Arlo, as they begin their exciting adventures and start collecting your stickers.</p>
					</div>
				</div>
			</div>
		</div>
	)
}

export default CardsSection
